$(document).ready(function ($) {
    var editStruct = $(".edit-struct-form");
    var editSocial = $(".edit-social-form");

    editStruct.on("submit", function (e) {
        e.preventDefault();
        if(validate($(this)) == false)
            return;

        var formName = $(this).attr("id");
        var field = formName.slice(0, -5);

        var value = $("#" + field).val();
        var text = $("." + $(this).attr("id"));
        text.find("p").text(value);

        $(this).addClass("hide");
        text.removeClass("hide");

            $.ajax({
                type: "POST",
                url: '/users/user-edit-profile/edit-user-struct-field',
                data: {
                    value: value,
                    field: field
                },
                success: success
            });

    });

    $(document).on('submit', '#email_form', function(e) {
        e.preventDefault();

        var emailValue = $('#email').val();

        if($('#user_header_email').text() === emailValue) {
            $(this).addClass('hide');
            $('.email_form').removeClass('hide');
        }
        else {
            if(!$('.field-email').hasClass('has-error')) {
                var lang = $('#lang-url').val();

                $.ajax({
                    type: "POST",
                    url: '/'+lang+'/users/user-edit-profile/edit-user-email',
                    data: {
                        email: emailValue,
                    },
                }).done(function (data) {
                    $('#myModalHasPassword').modal('show')
                        .find('.modal-content')
                        .html(data);
                });
            }

        }
    });

    $(document).on("reset", '#email_form_1',function (e) {
        $('#myModalHasPassword').modal('hide');
    });

    $(document).on('reset', '#email_form', function(e) {
        var text = $("." + $(this).attr("id"));
        $(this).addClass("hide");
        text.removeClass("hide");
        $(this).find('#email').val($('#user_header_email').text());
        e.preventDefault();
    });


    editStruct.on("reset", function (e) {
        var text = $("." + $(this).attr("id"));

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    });

    editSocial.on("submit", function (e) {

         e.preventDefault();

        if(validateSocialUrl($(this)) == false)
            return;

        var facebook_profile = $("#facebook_profile").val();
        var google_profile = $("#google_profile").val();
        var linkedin_profile = $("#linkedin_profile").val();

        $(".linkedin_profile").attr("href", linkedin_profile);
        $(".google_profile").attr("href", google_profile);
        $(".facebook_profile").attr("href", facebook_profile);

        $(this).addClass("hide");
        $(".social_form").removeClass("hide");

        $.ajax({
            type: "POST",
            url: '/users/user-edit-profile/edit-user-social',
            data: {
                facebook_profile: facebook_profile,
                google_profile: google_profile,
                linkedin_profile: linkedin_profile
            },
        }).done(function() {
            window.location.reload();
        });
        // e.preventDefault();

    });

    function validateSocialUrl(obj) {
        var _isValid = true;
        var fields = obj.find(".wrong-url-format");

        fields.each(function (i) {
            if(!checkUrl($(this).val())){
                $(this).parent(".form-group").addClass("has-error");
                _isValid = false;
            }
        })

        return _isValid;
    }

    function checkUrl(url)
    {
        //regular expression for URL
        var pattern = /^(http|https)?:\/\/[a-zA-Z0-9-\.]+\.[a-z]{2,4}/;

        if(pattern.test(url) || url == ''){
            return true;
        } else {
            return false;
        }
    }

    // $(".wrong-url-format").on("change", function (e) {
    //     if(!$(this).val()){
    //         $(this).parent().addClass("has-error");
    //     }else{
    //         $(this).parent().removeClass("has-error");
    //     }
    // });


    editSocial.on("reset", function (e) {
        var text = $(".social_form");

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    });


    $(".edit-image").on('click', function (e) {
        e.preventDefault();

        $(".image-upload").removeClass("hide");
        $(".img-resume").addClass("hide");
    });


    $(".cancel-image").on('click', function (e) {
        e.preventDefault();

        $(".image-upload").addClass("hide");
        $(".img-resume").removeClass("hide");
    })

    $('#userUploadImage').on('fileclear', function (event) {

        $.ajax({
            type: "POST",
            url: '/users/resume/delete-user-image',
       
        }).done(function (data) {
                if (data == 'true') {
                    window.location.reload(true);
                }
            }
        );
    });
    
    
    function success() {
        window.location.reload(true);
    }
    
    $(".completeness").hover( function () {
        $("#completeness-hover").stop().show();
    }, function () {
        $("#completeness-hover").stop().hide();
    });

    function validate(obj) {
        var _isValid = true;
        var fiealds = obj.find(".required-field");

        fiealds.each(function (i) {
            if(!$(this).val()){
                $(this).parent(".form-group").addClass("has-error");
                _isValid = false;
            }
        })

        return _isValid;
    }

    $("#phone").mask("(999) 999-999?, (999) 999-999",{placeholder:" "});

});


